<script>
import InputSwitch from 'tripod-styles/src/components/Inputs/InputSwitch.svelte';
import MinimalCard from "../custom_cards/MinimalCard.svelte";
import CardPlans from "../CardPlans.svelte";

export let changeInterval;
export let lang;
export let membership_selected
export let onSelectPlan;
export let affiliate;
export let user;
export let interval;
export let customCardPlan;
export let tripod_plans;

</script>

<div class="columns is-multiline">
    <div class="column">
        <div class="box-plans">
            <div class="flex-center has-text-centered">
                <InputSwitch classes={"is-marginless"} name="interval" on_change={(e)=>{ changeInterval(e.target) }}>
                    <svelte:fragment let:id={id} slot="label1">
                        <label class="has-text-weight-semibold has-text-light" for="{id}" style="font-size: 14px;">
                            <span class="is-capitalized has-text-dark font-size-14 fw500">
                                {lang.month}
                            </span>
                        </label>
                    </svelte:fragment>
                    <svelte:fragment let:id={id} slot="label2">
                        <label class="has-text-weight-semibold has-text-light" for="{id}">
                            <span class="is-capitalized has-text-dark font-size-14 fw500" style="margin-left:5px;">
                                {lang.year}
                            </span>
                        </label>
                    </svelte:fragment>
                </InputSwitch>
                <br>
            </div>
            <div class="columns is-multiline is-centered">
                {#if customCardPlan === "minimal"}
                    <MinimalCard membership_selected={membership_selected} onSelectPlan={onSelectPlan} affiliate={affiliate} user={user} interval={interval} tripod_plans={tripod_plans} />
                {/if}
                {#if customCardPlan === "default"}
                    <CardPlans membership_selected={membership_selected} onSelectPlan={onSelectPlan} affiliate={affiliate} user={user} interval={interval} tripod_plans={tripod_plans} />
                {/if}
            </div>
            <p class="has-text-centered has-text-dark" style="padding-top: 2rem;">
                {lang.help.needhelp}
            </p>
            <p class="has-text-centered">
                <a rel="noreferrer" href="https://3pod.io/contactanos" target="_blank" class="has-text-primary fw600">
                    {lang.help.contactus}
                </a>
            </p>
        </div>
    </div>
</div>